import { render, staticRenderFns } from "./crateMovements.vue?vue&type=template&id=a38cc626"
import script from "./crateMovements.vue?vue&type=script&lang=js"
export * from "./crateMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a38cc626')) {
      api.createRecord('a38cc626', component.options)
    } else {
      api.reload('a38cc626', component.options)
    }
    module.hot.accept("./crateMovements.vue?vue&type=template&id=a38cc626", function () {
      api.rerender('a38cc626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/crateMovements.vue"
export default component.exports